var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStemArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84598 19.0767L1.12809 11.401C0.923993 11.221 0.760527 10.9997 0.64856 10.7516C0.536591 10.5036 0.478688 10.2346 0.478688 9.96246C0.478688 9.69033 0.536593 9.42131 0.64856 9.17327C0.760526 8.92524 0.923989 8.70387 1.12809 8.52387L9.84616 0.849605L11.498 2.72614L4.69738 8.71254L19.125 8.71254L19.125 11.2125L4.69719 11.2125L11.498 17.2003L9.84598 19.0767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStemArrowLeft);
export default __webpack_public_path__ + "static/media/stem-arrow-left.83ab623f.svg";
export { ForwardRef as ReactComponent };